"use strict";
import {on, closest, trigger, findIn} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-table-row-link', function (link) {
        let tableRow = closest('tr', link);
        on('click', function (evt) {
            link.click();
        }, tableRow);
    });
}